// extracted by mini-css-extract-plugin
module.exports = {"text":"Text-module--text--36qUe"};